import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-fee";
const API_PATH_EXCEL = ConstantList.API_EN_POINT + "/excel";

export const pagingServiceFee = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getServiceFeeById = (serviceFeeId) => axios.get(API_PATH + "/getbyid/" + serviceFeeId);

export const saveOrUpdateServiceFee = serviceFee => axios.post(API_PATH + "/save", serviceFee);

export const deleteServiceFee = serviceFeeId => axios.delete(API_PATH + '/mark-delete/' + serviceFeeId);

export const downloadTemplate = () => {
  const url = API_PATH_EXCEL + "/dowload-template-service-fee";
  return axios.post(
    url,
    {},
    {
      responseType: "blob",
    }
  );
};